<template>
    <div>
        <div v-if="crear">
            <Curso titulo="Nuevo Curso" estado="crear" />
        </div>
        <div v-else-if="editar">
            <Colegio titulo="Editar Colegio" estado="editar"/>
        </div>
        <div v-else>
            <b-row class="border-bottom" style="background-color: rgba(255,225,0,0.1);">
                <b-col cols="3" class="pt-3">
                    <b-breadcrumb :items="migas"></b-breadcrumb>
                </b-col>
                <b-col cols="9" class="border-left text-left pt-3">
                    <b-button id="btn_edit_coleg" variant="link" @click="editar=!editar">
                        <b-icon icon="pencil-square" font-scale="2" variant="info"></b-icon>
                    </b-button>
                    <b-tooltip target="btn_edit_coleg">Editar colegio</b-tooltip>
                    <b-button id="btn_creacion" variant="link" @click="crear=!crear">
                        <b-icon icon="file-earmark-plus" font-scale="2" variant="info"></b-icon>
                    </b-button>
                    <b-tooltip target="btn_creacion">Crear curso</b-tooltip>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2" class="mt-3 mb-3" v-for="(curso, index) of cursos" :key="index">
                    <router-link :to="{name: 'notas', params: {'curso': curso._id}}">
                    <b-button variant="link">
                        <b-icon icon="table" font-scale="4" variant="info"></b-icon>
                    </b-button>
                    </router-link>
                    <p><strong>{{curso.nombre}}</strong></p>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
import Colegio from '@/components/Colegio.vue'
import Curso from '@/components/Curso.vue'
/*function Curso(nombre, grado, colegio) {
    this.nombre = nombre
    this.grado = grado
    this.colegio = colegio
}*/
export default {
    name: 'Cursos',
    components: {
        Colegio,
        Curso
    },
    data() {
        return {
            colegio_id: 0
            //cursosFiltrados: []            
        }
    },
    created() {
        this.colegio_id = this.$route.params.colegio
        //console.log('Creado...', coleg)
        let coleg = this.colegios.find(item => item._id === this.colegio_id)
        this.agregarMiga({
            text: coleg.nombre,
            to: {name: 'cursos', params: {colegio: coleg._id}}
        })
        //console.log('Ruta agregada...', this.migas)
        this.obtenerCursos(this.colegio_id)
        //this.cursosFiltrados = this.filtrarCursos()
    },
    /*beforeUpdate() {
        if (!this.crear) this.cursosFiltrados = this.filtrarCursos()
    },*/
    computed: {
        ...mapState(['migas','colegios','cursos']),
        //curso
        crear: {
            get () {return this.$store.state.mostrar_form_curso},
            set (valor) {this.$store.commit('mostrarFormCurso', valor)}
        },
        //colegio
        editar: {
            get () {return this.$store.state.mostrar_form_colegio},
            set (valor) {this.$store.commit('mostrarFormColegio', valor)}
        }
    },
    methods: {
        ...mapMutations(['agregarMiga','agregarCurso','reiniciarCursos']),
        filtrarCursos() {
            return this.cursos.filter(item => item.colegio === this.colegio_id)
        },
        obtenerCursos(colegio) {
            this.reiniciarCursos();
            this.axios.get(`/cursos/${colegio}`)
                .then(res => {
                    res.data.forEach(cur => {
                        this.agregarCurso(cur)                        
                    });
                })
                .catch(e => {
                    console.log(e)
                })
        }
    }
}
</script>